import * as React from 'react';

import { TestingStatusMainProps } from './types';
import { TestingStatus } from './TestingStatus';

const TestingStatusMain = ({ tableHeader, checks, handleClick, typeCheck, typeStage, tabsStageAlphas }: TestingStatusMainProps) => (
  <React.Fragment>
    {checks && (
      <div className="summary__testing">
        <div className="sumary__testing-checks">
          <TestingStatus
            checks={checks}
            handleClick={handleClick}
            typeCheck={typeCheck}
            type={tabsStageAlphas[typeStage].label}
            tableInfoTypes={tableHeader.summary}
          />
        </div>
      </div>
    )}
  </React.Fragment>
);

export default TestingStatusMain;
